export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dynamic%20sports%20arena%20atmosphere%20with%20warm%20golden%20and%20red%20lighting%2C%20grand%20stadium%20silhouette%2C%20dramatic%20cinematic%20composition%2C%20dark%20moody%20background%2C%20no%20visible%20text%2C%20abstract%20sports%20energy&width=1600&height=600&seq=cta-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-900/90 via-primary-800/80 to-primary-900/90"></div>
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-3">
          立即加入开云体育，开启您的精彩赛事之旅
        </h2>
        <p className="text-sm md:text-base text-white/70 mb-8 max-w-xl mx-auto">
          注册即享专属福利礼包，5000万用户信赖之选
        </p>
        <div className="flex items-center justify-center gap-4 flex-wrap">
          <a
            href="#"
            className="px-8 py-3 bg-accent-500 text-foreground-900 font-semibold rounded-md hover:bg-accent-400 transition-all duration-300 cursor-pointer whitespace-nowrap text-sm md:text-base"
          >
            立即注册
          </a>
          <a
            href="#"
            className="px-8 py-3 border-2 border-white/30 text-white font-medium rounded-md hover:border-white hover:bg-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap text-sm md:text-base"
          >
            了解更多
          </a>
        </div>
      </div>
    </section>
  );
}